module.exports = __webpack_public_path__ + "static/media/react-logo.c33873b0.svg";